module.exports = function() {
  return new Worker(__webpack_public_path__ + "a9f4eb9ac62e21b78d69.worker.js");
};